import { useEffect } from 'react';

import { TransportationMode } from '@/domain/impact-co2/entities/question.entity';
import { PositionGeocode } from '@/domain/position-geocode/position-geocode.entity';
import {
  calculateDistanceBetweenCoordinates,
  DistanceCalculationOptions,
} from '@/domain/position-geocode/utils/calculate-distance/calculate-distance';

export function useComputeTravelDistance({
  fromPosition,
  toPosition,
  transportationMode,
  returnTrip,
  onDistanceComputed,
}: {
  fromPosition: PositionGeocode | undefined;
  toPosition: PositionGeocode | undefined;
  transportationMode: TransportationMode;
  returnTrip: boolean;
  onDistanceComputed?: (distance: number | undefined) => void;
}): void {
  useEffect(() => {
    const computeDistance = async () => {
      const from = fromPosition?.coordinates;
      const to = toPosition?.coordinates;
      const options = prepareDistanceCalculationOptions(transportationMode);
      let distance = await calculateDistanceBetweenCoordinates(
        from,
        to,
        options,
      );
      if (returnTrip) {
        distance = distance * 2;
      }
      if (onDistanceComputed) {
        onDistanceComputed(distance);
      }
    };
    if (onDistanceComputed && fromPosition && toPosition) {
      computeDistance();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fromPosition, toPosition, returnTrip, transportationMode]);
}

function prepareDistanceCalculationOptions(
  transportationMode: TransportationMode,
): DistanceCalculationOptions {
  const HAVERSINE_MODES: TransportationMode[] = [
    'SHORT_HAUL_FLIGHT',
    'MEDIUM_HAUL_FLIGHT',
    'LONG_HAUL_FLIGHT',
    'FERRY',
  ];
  if (HAVERSINE_MODES.includes(transportationMode)) {
    return { type: 'haversine' };
  } else {
    return { type: 'road' };
  }
}
